/** @type {import('../help-index.js').HelpSidebarItem} */
export const FIN_CRC_SETTLEMENT_ITEM = {
  id: 'settlement',
  screenId: 'fin-crc-settlement',
  label: 'Liquidaciones',
  description: 'Depósitos de la procesadora y conciliación con cupones.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Registrás lo que la procesadora te acreditó en el banco por las ventas con tarjeta: monto bruto, arancel e impuestos. Luego vinculás los cupones del sistema hasta que el total conciliado coincida con lo liquidado.',
      },
      {
        title: 'Pestaña Diaria',
        paragraphs: [
          'Es la pantalla operativa de liquidaciones. Usala para cada depósito o liquidación que recibís de la procesadora.',
        ],
      },
      {
        title: 'Pestaña Mensual',
        paragraphs: [
          'Esta vista está en preparación y aún no tiene funciones disponibles.',
        ],
      },
      {
        title: 'Paso 1 — Listado de liquidaciones (Diaria)',
        fields: [
          { label: 'Proveedor', description: 'Procesadora de tarjetas.' },
          { label: 'Fecha desde / Fecha hasta', description: 'Período a consultar.' },
        ],
        bullets: [
          'Columnas: Fecha, Proveedor, Marca, Monto, Comisión, Impuestos, Liquidado (neto), Usuario, Fecha carga, Estado.',
          'Estado Abierta — podés agregar o quitar cupones. Cerrada — ya no se modifica.',
          'Liquidado = Monto − Comisión − Impuestos (calculado en la grilla).',
          'Tocá una fila para ver cupones vinculados. Ícono ✓ cierra la liquidación; papelera elimina (solo abiertas).',
        ],
      },
      {
        title: 'Paso 2 — Nueva liquidación',
        intro: 'El botón + abre «Agregar liquidación». Campos obligatorios:',
        fields: [
          { label: 'Marca de tarjeta', description: 'Visa, Mastercard, etc., según el proveedor seleccionado.' },
          { label: 'Banco pagador', description: 'Cuenta bancaria donde se acreditó el neto (según tus terminales POS).' },
          { label: 'Fecha de la liquidación', description: 'Fecha del depósito o liquidación informada.' },
          { label: 'Total presentado', description: 'Monto bruto antes de descuentos.' },
          { label: 'Arancel', description: 'Comisión de la procesadora.' },
          { label: 'Impuestos', description: 'Retenciones e impuestos descontados.' },
          { label: 'Total liquidado', description: 'Se calcula solo: Total presentado − Arancel − Impuestos.' },
        ],
        paragraphs: [
          'Al crear, el sistema puede vincular automáticamente cupones controlados con la misma fecha de pago. Te avisa si quedó diferencia o si no encontró coincidencias.',
        ],
      },
      {
        title: 'Paso 3 — Detalle y conciliación de cupones',
        bullets: [
          'Ves resumen: monto total, comisión, impuestos, total liquidado, monto conciliado (suma de cupones) y diferencia.',
          'Podés cerrar si la diferencia no supera 2 centavos por cada cupón vinculado (por ejemplo, 3 cupones permiten hasta 0,06).',
          'Botón + agrega cupones disponibles desde una lista.',
          'Papelera en un cupón lo desvincula de la liquidación.',
          '«Cerrar liquidación» es irreversible: después no podés agregar ni quitar cupones.',
        ],
      },
    ],
  },
}
